<template>
    <div>
        <page-header
            :text="$t('navigation.my_systems')"
            :searchField="{
                placeholder: $t('systems.search'),
                inputEmitEvent: 'search',
                allowedFields: searchFields,
                nameTranslation: 'system',
                savedSearchName: 'search-system-user',
            }"
            @search="searchHandler"
        />

        <div class="table-wrapper">
            <table class="table table-filter table--striped table--filterable" v-if="items">
                <thead>
                    <tr>
                        <th v-for="field in fields" :key="field.value" class="table-filter__trigger" :width="field.width">
                            <div>{{ $t(field.title) }}</div>
                            <div
                                v-if="field.sortable"
                                class="table-filter__sorting"
                                @click="sortClickHandler(field.value)"
                                :class="{
                                    asc: activeSorting[field.value] === 'asc',
                                    desc: activeSorting[field.value] === 'desc',
                                }"
                            >
                                <i class="icon icon--common-caret"></i>
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="system in filteredSystems"
                        :key="system.id"
                        class="table__row table__row--clickable"
                        @click.exact="$router.push('/systems/' + system.id)"
                        @click.middle="openWindow('/systems/' + system.id)"
                        @click.ctrl="openWindow('/systems/' + system.id)"
                        @click.meta="openWindow('/systems/' + system.id)"
                    >
                        <td>
                            <b>{{ system.name }}</b>
                        </td>
                        <td>
                            {{ formatSystemAddress(system) }}
                        </td>
                        <td>
                            {{ getUserRole(system, userData.id) }}
                        </td>
                        <td>
                            <SystemLabels :system="system" />
                        </td>
                        <td class="centered">
                            <alarm-message :alarm="system.latest_alarm" :tooltip="true" />
                        </td>
                    </tr>
                </tbody>

                <tr v-if="items.length === 0">
                    <td class="no-padding" colspan="5">
                        <div class="alert alert--danger no-margin-bottom" role="alert">
                            {{ $t('systems.no_systems_connected') }}
                        </div>
                    </td>
                </tr>

                <TablePagination
                    v-if="paginationData"
                    :paginationData="paginationData"
                    :visibleAmount="searchedItems ? searchedItems.length : items.length"
                    @goToPrevPage="prevPageHandler"
                    @goToNextPage="nextPageHandler"
                />
            </table>
        </div>
    </div>
</template>

<script>
import systemsTable from '@/mixins/systemsTable';
import PageHeader from '@/components/PageHeader';
import AlarmMessage from '@/components/AlarmMessage';
import openWindow from '@/mixins/openWindow';
import TablePagination from '@/components/TablePagination';
import SystemLabels from '@/components/SystemLabels';
import paginatedTable from '@/mixins/paginatedTable';
import { mapState } from 'vuex';

export default {
    name: 'systems-user',
    components: {
        PageHeader,
        AlarmMessage,
        TablePagination,
        SystemLabels,
    },
    mixins: [openWindow, paginatedTable, systemsTable],
    data() {
        return {
            apiType: 'systems',
            searchApi: 'search',
            responseField: 'systems',
            additionalParams: { userSystems: true, include_users: true },
            searchFields: ['name', 'address', 'label', 'errorcode'],
            fields: [
                {
                    value: 'name',
                    title: 'systems.system',
                    sortable: true,
                    width: '25%',
                },
                {
                    value: 'address1',
                    title: 'systems.address',
                    sortable: true,
                    width: '35%',
                },
                {
                    value: 'role',
                    title: 'organizations.role',
                    sortable: false,
                    width: '8%',
                },
                {
                    value: 'labels',
                    title: 'fields.labels',
                    sortable: false,
                    width: '15%',
                },
                {
                    value: 'latest_alarm',
                    title: 'systems.logs.message',
                    sortable: false,
                    width: '8%',
                },
            ],
        };
    },
    computed: {
        ...mapState(['userData']),
        filteredSystems() {
            if (!this.items) return [];
            if (this.searchedItems) return [...this.searchedItems];
            return [...this.items];
        },
    },
    watch: {
        $route: 'loadItems',
    },
    created() {
        this.loadItems();
    },
};
</script>
